var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoneSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-zone-settings1, .cls-zone-settings2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-zone-settings2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_108",
    "data-name": "Groupe 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_110",
    "data-name": "Groupe 110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    className: "cls-zone-settings2",
    x: 0.67,
    y: 4.17,
    width: 16.17,
    height: 28.37,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_21",
    "data-name": "Ligne 21",
    className: "cls-zone-settings2",
    x1: 0.67,
    y1: 7.71,
    x2: 16.84,
    y2: 7.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    className: "cls-zone-settings1",
    x: 3.37,
    y: 10.38,
    width: 10.86,
    height: 19.29
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_22",
    "data-name": "Ligne 22",
    className: "cls-zone-settings1",
    x1: 3.37,
    y1: 15.95,
    x2: 14.23,
    y2: 15.95
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_23",
    "data-name": "Ligne 23",
    className: "cls-zone-settings1",
    x1: 5.65,
    y1: 15.95,
    x2: 5.65,
    y2: 13.99
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_24",
    "data-name": "Ligne 24",
    className: "cls-zone-settings1",
    x1: 8.75,
    y1: 15.95,
    x2: 8.75,
    y2: 13.99
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_25",
    "data-name": "Ligne 25",
    className: "cls-zone-settings1",
    x1: 11.84,
    y1: 15.95,
    x2: 11.84,
    y2: 13.99
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_26",
    "data-name": "Ligne 26",
    className: "cls-zone-settings1",
    x1: 3.37,
    y1: 21.51,
    x2: 14.23,
    y2: 21.51
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_27",
    "data-name": "Ligne 27",
    className: "cls-zone-settings1",
    x1: 5.65,
    y1: 21.51,
    x2: 5.65,
    y2: 19.55
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_28",
    "data-name": "Ligne 28",
    className: "cls-zone-settings1",
    x1: 8.75,
    y1: 21.51,
    x2: 8.75,
    y2: 19.55
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_29",
    "data-name": "Ligne 29",
    className: "cls-zone-settings1",
    x1: 11.84,
    y1: 21.51,
    x2: 11.84,
    y2: 19.55
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_30",
    "data-name": "Ligne 30",
    className: "cls-zone-settings1",
    x1: 3.37,
    y1: 26.57,
    x2: 14.23,
    y2: 26.57
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_31",
    "data-name": "Ligne 31",
    className: "cls-zone-settings1",
    x1: 5.65,
    y1: 26.57,
    x2: 5.65,
    y2: 24.61
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_32",
    "data-name": "Ligne 32",
    className: "cls-zone-settings1",
    x1: 8.75,
    y1: 26.57,
    x2: 8.75,
    y2: 24.61
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_33",
    "data-name": "Ligne 33",
    className: "cls-zone-settings1",
    x1: 11.84,
    y1: 26.57,
    x2: 11.84,
    y2: 24.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    className: "cls-zone-settings2",
    d: "m20.02,30.5c.1.04.2.08.3.12.36.13.61.47.6.86,0,.5,0,1.93,0,2.14h3.58v-2.01c0-.59.22-.85.77-1.05.56-.2,1.11-.42,1.65-.67.59-.27.89-.25,1.35.21s.92.92,1.36,1.37l2.54-2.54c-.46-.46-.93-.93-1.4-1.4-.41-.41-.44-.74-.2-1.26.25-.54.48-1.09.69-1.65.23-.65.45-.82,1.15-.82h1.93v-3.58c-.72,0-1.41,0-2.11,0-.41.01-.77-.24-.89-.63-.26-.66-.53-1.31-.81-1.96-.19-.36-.11-.8.19-1.08.39-.4,1.43-1.35,1.53-1.42l-2.64-2.65c-.05.08-.99,1.1-1.42,1.52-.29.32-.75.39-1.13.18-.62-.27-1.25-.53-1.88-.78-.42-.12-.7-.51-.67-.95,0-.61,0-1.99,0-2.08h-3.58v1.97c0,.65-.19.88-.81,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    className: "cls-zone-settings2",
    d: "m20.02,17.36c2.56-1.49,5.85-.62,7.34,1.94,1.49,2.56.62,5.85-1.94,7.34-1.67.97-3.73.97-5.4,0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_34",
    "data-name": "Ligne 34",
    className: "cls-zone-settings2",
    x1: 3.37,
    y1: 33.86,
    x2: 3.37,
    y2: 32.54
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_35",
    "data-name": "Ligne 35",
    className: "cls-zone-settings2",
    x1: 14.23,
    y1: 33.86,
    x2: 14.23,
    y2: 32.54
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneSettings);
export default __webpack_public_path__ + "static/media/zone_settings.b2e543c0595afb81762907946181463f.svg";
export { ForwardRef as ReactComponent };